<template>
  <div class="audio-list">
    <div class="list-title">课程列表（{{ mediaList.length }}）</div>
    <div :class="mediaList.length <= 8 ? 'more-list' : 'small-list'">
      <div v-if="mediaList.length > 8">
        <div
          class="content"
          v-for="(item, index) in mediaList"
          :key="index"
          @click="switchMedia(item, index)"
        >
          <div
            class="content-icon"
            :class="atSelectMedia.index == index ? 'audio-active' : ''"
          >
            <div>
              <span
                :class="mediaState ? 'audioMusicPlay' : 'audioMusicStop'"
              ></span>
              <span
                :class="mediaState ? 'audioMusicPlay' : 'audioMusicStop'"
              ></span>
              <span
                :class="mediaState ? 'audioMusicPlay' : 'audioMusicStop'"
              ></span>
            </div>
          </div>
          <div
            class="content-text"
            :class="atSelectMedia.index == index ? 'audio-active' : ''"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div v-if="mediaList.length <= 8">
        <div
          class="content"
          v-for="(item, index) in mediaList"
          :key="index"
          @click="switchMedia(item, index)"
        >
          <div class="left">
            <img :src="item.imageUrl" />
          </div>
          <div class="right">
            <div>
              <p
                :class="
                  atSelectMedia.index == index
                    ? 'video-active text-overflow'
                    : 'text-overflow'
                "
              >
                {{ item.title }}
              </p>
              <p class="text-overflow">{{ item.subTitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mediaState: {
      type: Boolean,
      default: false,
    },

    mediaList: {
      type: Array,
      default: [],
    },
    atSelectMedia: {
      type: Object,
      default: "",
    },
    switchMedia: {
      type: Function,
      default: () => console.log("切换音频"),
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@style/main.scss";
.audio-list {
  .list-title {
    position: relative;
    z-index: 99;
    background: #fff;
    line-height: rem(77);
    border-top: rem(10) solid #f6f6f6;
    border-bottom: 1px solid #e0e0e0;
    padding: 0 rem(30);
    font-size: rem(30);
    color: #3c3c3f;
    font-weight: bold;
  }

  .small-list {
    padding-bottom: rem(40);
    .content {
      margin-top: rem(40);
      display: flex;
      flex-direction: row;
      line-height: rem(42);
      align-items: center;
      padding: 0 rem(30);

      .content-icon {
        position: relative;
        width: rem(50);
      }

      .content-text {
        word-break: break-word;
        font-size: rem(30);
        color: #333;
      }
    }
  }

  .more-list {
    padding-bottom: rem(40);
    .content {
      margin-top: rem(40);
      display: flex;
      flex-direction: row;
      padding: 0 rem(30);

      .left {
        width: rem(174);
        height: rem(174);

        img {
          width: 100%;
          height: 100%;
          border-radius: rem(12);
        }
      }

      .right {
        margin-left: rem(20);
        display: flex;
        align-items: center;
        width: rem(480);

        p {
          &:nth-child(1) {
            font-size: rem(30);
            color: #333;
            font-weight: bold;
            line-height: rem(35);
            word-break: break-word;
          }

          &:nth-child(2) {
            margin-top: rem(20);
            font-size: rem(24);
            color: #929292;
            line-height: rem(30);
            word-break: break-word;
          }
        }
      }
    }
  }
}

.audio-active {
  color: #dc1616 !important;
  div {
    width: rem(30);
    height: rem(30);
  }
  span {
    display: inline-block;
    position: absolute;
    bottom: rem(5);
    width: rem(5);
    height: rem(30);
    background-color: rgb(243, 25, 25);
    transform-origin: bottom;
    border-radius: 5px 5px 0 0;

    &:nth-child(1) {
      left: 0px;
      animation: musicWave 0.5s infinite linear both alternate;
    }
    &:nth-child(2) {
      left: rem(10);
      animation: musicWave 0.2s infinite linear both alternate;
    }
    &:nth-child(3) {
      left: rem(20);
      animation: musicWave 0.3s infinite linear both alternate;
    }
  }
}
.video-active {
  color: #dc1616 !important;
}
.audioMusicStop {
  animation-play-state: paused !important;
}

.audioMusicPlay {
  animation-play-state: running !important;
}

@keyframes musicWave {
  0% {
    height: rem(10);
  }
  100% {
    height: rem(20);
  }
}

.text-overflow {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>